import type { MagentoBrandConsumables } from "@jti/magento-types";
import type { BrandWithFlavorItems } from "@jti/ui/components/MultibrandMultipleFlavorsSelector";
import type { MultipleFlavorsSelectorItem } from "@jti/ui/components/MultipleFlavorsSelector";

export const getMultipleFlavorsWithBrands = (
  flavors: MultipleFlavorsSelectorItem[],
  brandMatrix: MagentoBrandConsumables[] | undefined
): BrandWithFlavorItems[] | undefined => {
  const brandsWithFlavors = brandMatrix
    ?.map((brand) => {
      const brandWithFlavors = flavors.filter((flavor) => flavor.brandOptionId === String(brand.productBrandOptionId));

      if (brandWithFlavors.length > 0) {
        return {
          brandId: String(brand.productBrandOptionId),
          brandLabel: brand.brandLabel,
          brandIconUrl: brand.brandIcon,
          items: brandWithFlavors,
        } as BrandWithFlavorItems;
      } else {
        return null;
      }
    })
    .filter((brandWithItems) => brandWithItems !== null);

  if (brandsWithFlavors && brandsWithFlavors.length > 1 && allItemsHaveBrand(flavors, brandsWithFlavors)) {
    return brandsWithFlavors;
  }

  return undefined;
};

function allItemsHaveBrand(flavors: MultipleFlavorsSelectorItem[], brandsWithFlavors: BrandWithFlavorItems[]) {
  return brandsWithFlavors?.reduce((acc, curr) => acc + curr.items.length, 0) === flavors.length;
}
